import { blinkConstants } from '@thoughtspot/blink-constants';
import { useTranslation } from '@thoughtspot/i18n';
import { Button } from '@thoughtspot/radiant-react/widgets/button';
import { Card, CardBody, CardFooter, CardHeader, } from '@thoughtspot/radiant-react/widgets/card';
import { IconID } from '@thoughtspot/radiant-react/widgets/icon';
import { Horizontal, Vertical, } from '@thoughtspot/radiant-react/widgets/layout';
import { Modal, } from '@thoughtspot/radiant-react/widgets/modal';
import { Toggle } from '@thoughtspot/radiant-react/widgets/toggle';
import { Colors, Typography, } from '@thoughtspot/radiant-react/widgets/typography';
import { isIamV2OidcEnabled, isInternalAuthEnabledForOkta, isPerOrgSubDomainEnabled, } from '@thoughtspot/session-service';
import { isOktaEnabled, isSamlEnabled, } from '@thoughtspot/system-config-service';
import React, { useEffect, useRef, useState } from 'react';
import { useGetLocalIamV1Query } from "../../../services/system/system-service";
import { SamlConnectionListQuery, useSaml_DownloadQuery, useSamlActDeactConnectionMutation, useSamlDeleteConnectionMutation, } from '../../../services/saml/saml-service';
import { getDefaultSamlHeaders, getOIDCLoginUrl, getSubDomainIfOrgEnabled, IDP_TYPE, TranslationsKeys, } from '../constant';
import styles from './provider-list.module.scss';
const defaultAlertData = {
    alertMessage: '',
    alertTitle: '',
    alertButtonText: '',
};
const statusConstants = {
    ACTIVE: 'ACTIVE',
    INACTIVE: 'INACTIVE',
};
const toggleTestId = 'toggle-id';
export const ProvierList = ({ setScreenloader, listIsEmpty, editConnection, remount, clientId, formDataRef, showHideBanner, currentOrgInfo, showIAMV2MigrationBannerWhenEnabled, setIdpNamesList, }) => {
    const { t } = useTranslation();
    const getTranslations = (key, args) => t(`${key}`, args);
    const [samlList, setSamlList] = useState([]);
    const [toggle, setToggle] = useState('');
    const [currentId, setCurrentId] = useState('');
    const [downloadId, setDownloadId] = useState('');
    const [alertState, setAlertState] = useState(false);
    const [onToggle, setOnToggle] = useState(false);
    const [removeClick, setRemoveClick] = useState(false);
    const [isCurrentIDPSaml, setIsCurrentIDPSaml] = useState(false);
    const [isLocalAuthEnabled, setIsLocalAuthEnabled] = useState(false);
    const providerListAlert = useRef(defaultAlertData);
    const isOktaSamlEnabled = isOktaEnabled() && isSamlEnabled();
    const onToggleSuccess = (response) => {
        const samlist = [...samlList];
        const newList = samlist.map(obj => obj.id === currentId
            ? obj.status === statusConstants.ACTIVE
                ? {
                    ...obj,
                    status: statusConstants.INACTIVE,
                }
                : {
                    ...obj,
                    status: statusConstants.ACTIVE,
                }
            : obj);
        setSamlList(newList);
        setCurrentId('');
        setScreenloader(false);
        setIsCurrentIDPSaml(false);
    };
    const onToggleError = () => {
        setCurrentId('');
        setScreenloader(false);
        setIsCurrentIDPSaml(false);
    };
    const [toggleClick] = useSamlActDeactConnectionMutation(response => {
        onToggleSuccess(response);
    }, (error) => {
        onToggleError();
    }, {
        id: currentId,
        isSaml: isCurrentIDPSaml,
        status: toggle === statusConstants.ACTIVE
            ? getTranslations(TranslationsKeys.ACTIVE)
            : getTranslations(TranslationsKeys.INACTIVE),
        clientId,
        defaultHeaders: getDefaultSamlHeaders(),
    });
    const [deleteConnection] = useSamlDeleteConnectionMutation(response => {
        setScreenloader(false);
        setCurrentId('');
        setIsCurrentIDPSaml(false);
        remount();
        formDataRef.current.id = '';
    }, (error) => {
        setScreenloader(false);
        setCurrentId('');
        setIsCurrentIDPSaml(false);
    }, {
        isSaml: isCurrentIDPSaml,
        id: currentId,
        clientId,
        defaultHeaders: getDefaultSamlHeaders(),
    });
    const onConfirmClick = () => {
        setAlertState(false);
        if (onToggle) {
            setOnToggle(false);
            toggleClick();
            setScreenloader(true);
        }
        else if (removeClick) {
            setRemoveClick(false);
            setScreenloader(true);
            deleteConnection();
        }
    };
    const primaryActionButton = {
        text: providerListAlert.current.alertButtonText,
        onConfirm: () => {
            onConfirmClick();
        },
    };
    const onCancelClick = () => {
        setAlertState(false);
        if (onToggle) {
            setOnToggle(false);
            onToggleError();
        }
        else if (removeClick) {
            setRemoveClick(false);
        }
    };
    const secondaryActionButton = {
        text: getTranslations(TranslationsKeys.CANCEL),
        onClick: () => {
            onCancelClick();
        },
    };
    const { data, loading, error } = SamlConnectionListQuery({
        clientId,
        isSaml: true,
        defaultHeaders: getDefaultSamlHeaders(),
    });
    const { data: oidcData, loading: oidcLoading, error: oidcError, } = SamlConnectionListQuery({
        clientId,
        defaultHeaders: getDefaultSamlHeaders(),
    });
    const { data: downloadData, loading: downloadLoading, error: downloadError, } = useSaml_DownloadQuery({
        clientId,
        id: downloadId,
        defaultHeaders: getDefaultSamlHeaders(),
    });
    const { data: internalAuthResponse, loading: isInternalAuthLoading, error: internalAuthError, } = useGetLocalIamV1Query();
    useEffect(() => {
        setScreenloader(true);
    }, []);
    const isValidOrgInfoInCurrentOrg = () => {
        return !!(currentOrgInfo &&
            currentOrgInfo.orgName &&
            currentOrgInfo.orgId !== blinkConstants.orgs.MASTER_ID.toString());
    };
    const updateList = (updatedList) => {
        let newSamList = updatedList;
        let idpNamesList = [];
        let subDomain = getSubDomainIfOrgEnabled();
        if (!subDomain) {
            subDomain = isValidOrgInfoInCurrentOrg()
                ? `${currentOrgInfo.orgName}_`
                : '';
        }
        newSamList = newSamList.filter((saml) => saml.connectionName.startsWith(subDomain));
        idpNamesList = newSamList.map((idp) => {
            const connection = idp;
            if (idp.connectionName.startsWith(subDomain)) {
                connection.connectionName = idp.connectionName.replace(subDomain, '');
            }
            return connection;
        });
        setIdpNamesList(idpNamesList);
        if (!newSamList || newSamList.length === 0)
            listIsEmpty();
        setSamlList(newSamList);
    };
    useEffect(() => {
        let isInternalAuthError = false;
        if (internalAuthError && isInternalAuthEnabledForOkta()) {
            const subDomain = getSubDomainIfOrgEnabled();
            if (subDomain && subDomain.length !== 0) {
                isInternalAuthError = isPerOrgSubDomainEnabled();
            }
            else {
                isInternalAuthError = true;
            }
        }
        const hasError = error || oidcError || isInternalAuthError;
        const isLoading = loading || oidcLoading || isInternalAuthLoading;
        if (hasError && !isLoading) {
            showIAMV2MigrationBannerWhenEnabled();
            setScreenloader(false);
            showHideBanner(isIamV2OidcEnabled()
                ? getTranslations(TranslationsKeys.OIDC_LIST_RETRIEVE_ERROR)
                : getTranslations(TranslationsKeys.LIST_RETRIEVE_ERROR), true);
        }
        else if (!hasError && !isLoading) {
            if (data || oidcData) {
                const samlList = (data?.Data.samlList || []).map(idp => ({
                    ...idp,
                    connectionName: idp.name,
                }));
                const newIdpList = [
                    ...samlList,
                    ...(oidcData?.Data.samlList || []),
                ];
                if (newIdpList.length === 0) {
                    showIAMV2MigrationBannerWhenEnabled();
                }
                setScreenloader(false);
                updateList(newIdpList);
            }
            if (internalAuthResponse) {
                const status = internalAuthResponse.Data?.status;
                setIsLocalAuthEnabled(status);
            }
        }
    }, [
        data,
        loading,
        error,
        oidcData,
        oidcError,
        oidcLoading,
        isInternalAuthLoading,
        internalAuthError,
        internalAuthResponse,
    ]);
    const canDisableConnection = () => {
        if (!isInternalAuthEnabledForOkta()) {
            return true;
        }
        const activeConnections = samlList.filter(item => item.status === statusConstants.ACTIVE)
            .length > 1;
        const subDomain = getSubDomainIfOrgEnabled();
        if (subDomain && subDomain.length !== 0) {
            if (isPerOrgSubDomainEnabled()) {
                return isLocalAuthEnabled || activeConnections;
            }
            return activeConnections;
        }
        return isLocalAuthEnabled || activeConnections;
    };
    const openWindow = (response) => {
        const xmlData = response.Status;
        setScreenloader(false);
        if (xmlData) {
            const file = new File([xmlData], 'SPMetadata', {
                type: 'text/xml',
            });
            const exportUrl = URL.createObjectURL(file);
            const downloadLink = document.createElement('a');
            downloadLink.href = exportUrl;
            downloadLink.download = 'SPMetadata.xml';
            downloadLink.click();
            setCurrentId('');
            setIsCurrentIDPSaml(false);
            URL.revokeObjectURL(exportUrl);
        }
        else {
            showHideBanner('Could not download SP Metadata', true);
        }
    };
    useEffect(() => {
        if (!downloadLoading) {
            if (downloadData) {
                openWindow(downloadData);
                setDownloadId('');
            }
            else if (downloadError) {
                setScreenloader(false);
                setDownloadId('');
            }
        }
    }, [downloadData, downloadLoading, downloadError]);
    const onToggleClick = (event, id, type) => {
        let status;
        if (!event.target.checked) {
            if (!canDisableConnection()) {
                showHideBanner(getTranslations(TranslationsKeys.CONNECTION_DISABLE_ERROR), true);
                return;
            }
            status = 'INACTIVE';
        }
        else {
            status = 'ACTIVE';
        }
        providerListAlert.current.alertTitle =
            status === statusConstants.ACTIVE
                ? getTranslations(TranslationsKeys.ALERT_ENABLE_TITLE)
                : getTranslations(TranslationsKeys.ALERT_DISABLE_TITLE);
        providerListAlert.current.alertButtonText =
            status === statusConstants.ACTIVE
                ? getTranslations(TranslationsKeys.BUTTON_ENABLE)
                : getTranslations(TranslationsKeys.BUTTON_DISABLE);
        providerListAlert.current.alertMessage =
            status === statusConstants.ACTIVE
                ? getTranslations(TranslationsKeys.ENABLE_MESSAGE)
                : getTranslations(TranslationsKeys.DISABLE_MESSAGE);
        setAlertState(true);
        setCurrentId(id);
        setToggle(status);
        setOnToggle(true);
        if (type === IDP_TYPE.SAML) {
            setIsCurrentIDPSaml(true);
        }
    };
    const onEditClick = (item) => {
        editConnection(item);
    };
    const onRemoveClick = (id, type) => {
        if (!canDisableConnection()) {
            showHideBanner(getTranslations(TranslationsKeys.CONNECTION_DISABLE_ERROR), true);
            return;
        }
        const removeDec = getTranslations(TranslationsKeys.REMOVE_PRO_DEC);
        const removeButton = getTranslations(TranslationsKeys.REMOVE_PRO_BUTTON);
        const removeTit = getTranslations(TranslationsKeys.REMOVE_PRO_TITLE);
        providerListAlert.current.alertMessage = removeDec;
        providerListAlert.current.alertTitle = removeTit;
        providerListAlert.current.alertButtonText = removeButton;
        setAlertState(true);
        setRemoveClick(true);
        setCurrentId(id);
        setIsCurrentIDPSaml(type === IDP_TYPE.SAML);
    };
    const getItemName = (name) => {
        let subDomain = getSubDomainIfOrgEnabled();
        if (!subDomain && currentOrgInfo) {
            subDomain = `${currentOrgInfo.orgName}_`;
        }
        return subDomain ? name.replaceAll(subDomain, '') : name;
    };
    const getFields = (fieldName, fieldValue) => {
        let label;
        let helpText;
        if (fieldName === 'issuer') {
            label = getTranslations(TranslationsKeys.ISSUER_LABEL);
            helpText = getTranslations(TranslationsKeys.ISSUER_LABEL_HELPTEXT);
        }
        else if (fieldName === 'sso_url') {
            label = getTranslations(TranslationsKeys.SSO_LABEL);
            helpText = getTranslations(TranslationsKeys.SSO_LABEL_HELPTEXT);
        }
        else if (fieldName === 'redirect_url') {
            label = getTranslations(TranslationsKeys.OIDC_REDIRECT_URI_LABEL);
            helpText = getTranslations(TranslationsKeys.SSO_LABEL_HELPTEXT);
        }
        return (React.createElement(Horizontal, { spacing: "c" },
            React.createElement(Horizontal, { spacing: "d" },
                React.createElement(Typography, { variant: "p-large", noMargin: true }, label),
                React.createElement(Button, { type: "secondary", icon: IconID.INFORMATION, size: "xs", backgroundType: "light", "data-tooltip-content": helpText, ariaLabel: helpText }),
                ":"),
            React.createElement(Vertical, { spacing: "c", vAlignContent: "top" },
                React.createElement(Typography, { variant: "p-large-bold", noMargin: true }, fieldValue))));
    };
    return (React.createElement(Vertical, null,
        React.createElement(Modal, { isOpen: alertState, title: providerListAlert.current.alertTitle, confirmButton: primaryActionButton, dismissButton: secondaryActionButton, className: styles.alertMaxWidth },
            React.createElement(Typography, { variant: "body-large", noMargin: true }, providerListAlert.current.alertMessage)),
        React.createElement(Vertical, null, samlList.map(item => (React.createElement(Card, { key: item.id, className: styles.cardContainer },
            React.createElement(CardHeader, null,
                React.createElement(Vertical, null,
                    React.createElement(Typography, { variant: "h3", noMargin: true }, getItemName(item.connectionName)),
                    React.createElement(Horizontal, { className: styles.cardHeader },
                        React.createElement(Toggle, { "data-testid": toggleTestId, label: item.status ===
                                statusConstants.ACTIVE
                                ? getTranslations(TranslationsKeys.ENABLED)
                                : getTranslations(TranslationsKeys.DISABLED), checked: item.status ===
                                statusConstants.ACTIVE, onChange: event => {
                                onToggleClick(event, item.id, item.type);
                            }, disabled: isOktaSamlEnabled, labelPosition: "right" }),
                        React.createElement(Button, { "data-testid": `edit${item.id}`, text: getTranslations(TranslationsKeys.EDIT), icon: IconID.PENCIL, isSelected: false, backgroundType: "light", type: "secondary", isDisabled: isOktaSamlEnabled, onClick: () => onEditClick(item) })))),
            React.createElement(CardBody, null,
                React.createElement(Vertical, { spacing: "e" },
                    item.issuer
                        ? getFields('issuer', item.issuer)
                        : '',
                    item.sso
                        ? getFields('sso_url', item.sso.url)
                        : '',
                    item.type !== IDP_TYPE.SAML
                        ? getFields('redirect_url', `${getOIDCLoginUrl(item.id)}`)
                        : '')),
            React.createElement(CardFooter, null,
                React.createElement(Horizontal, { className: styles.cardFooter },
                    item.type === IDP_TYPE.SAML && (React.createElement(Horizontal, { tabIndex: 0, "aria-label": "Download metadata xml" },
                        React.createElement(Typography, { className: styles.metadataDownloadButton, variant: "p", "data-testid": `downloadMetadata${item.id}`, onClick: (event) => {
                                setScreenloader(true);
                                setDownloadId(item.id);
                            }, color: Colors.accent }, getTranslations(TranslationsKeys.DOWNLOAD_META)))),
                    React.createElement(Typography, { variant: "p" }, `IDP Type : ${item.type}`),
                    React.createElement(Horizontal, { className: styles.removeButton },
                        React.createElement(Button, { text: getTranslations(TranslationsKeys.REMOVE), icon: IconID.TRASH_CAN, isSelected: false, backgroundType: "light", type: "secondary", isDisabled: isOktaSamlEnabled, onClick: () => {
                                onRemoveClick(item.id, item.type);
                            } }))))))))));
};
//# sourceMappingURL=provider-list.container.js.map